import React from "react";
import { Grid, SpaceBetween } from "@amzn/awsui-components-react";
import { FixedFeeConfig } from "@amzn/fuse-accounting-central-datastore-client";
import Collapsible from "src/pages/commons/collapsible";
import { Domain } from "src/config/BartLambdaConfig";
import { TopLevelTable } from "./top-level-table";
import { EstimateBreakdownTable } from "./estimate-breakdown-table";
import { InvoiceBreakdownTable } from "./invoice-breakdown-table";
import { AdjustmentsTable } from "./adjustments-table";
import "src/lambda/transactionSearchLambda/payload-display.css";

interface Props {
  fixedFeeConfig: FixedFeeConfig;
  domain: Domain;
}

// Main display component
export const FixedFeeConfigDisplay: React.FC<Props> = ({
  fixedFeeConfig,
  domain,
}) => {
  // Full JSON dump in collapsible section
  const fullJsonBlob = (
    <Collapsible open={false} title="Full JSON Output">
      <pre className="sourceInfo">
        {JSON.stringify(fixedFeeConfig, null, 2)}
      </pre>
    </Collapsible>
  );

  const hasEstimateAndInvoice =
    fixedFeeConfig.estimateBreakdown &&
    Object.keys(fixedFeeConfig.estimateBreakdown).length > 0 &&
    fixedFeeConfig.invoiceBreakdown &&
    Object.keys(fixedFeeConfig.invoiceBreakdown).length > 0;

  return (
    <div style={{ paddingLeft: "10px" }}>
      <SpaceBetween size="l">
        <TopLevelTable fixedFeeConfig={fixedFeeConfig} />
        {hasEstimateAndInvoice ? (
          <Grid gridDefinition={[{ colspan: 4 }, { colspan: 8 }]}>
            <EstimateBreakdownTable fixedFeeConfig={fixedFeeConfig} />
            <InvoiceBreakdownTable fixedFeeConfig={fixedFeeConfig} />
          </Grid>
        ) : (
          <>
            <EstimateBreakdownTable fixedFeeConfig={fixedFeeConfig} />
            <InvoiceBreakdownTable fixedFeeConfig={fixedFeeConfig} />
          </>
        )}
        <AdjustmentsTable fixedFeeConfig={fixedFeeConfig} domain={domain} />
        {fullJsonBlob}
      </SpaceBetween>
    </div>
  );
};
